module.exports = __webpack_public_path__ + "img/p05.d85aa42d.jpg";